<div class="row full-height">
  <div class="col-md-12 col-sm-12">
    <form #addToCampaignForm="ngForm" class="add-to-campaign-form d-flex" [ngClass]="{'add-post': totalSelectedPost}" novalidate (ngSubmit)="addToCampaign()">
      <div class="d-flex flex-column flex-auto">
        <div class="bottombar-buttons" *ngIf="!totalSelectedPost">
          <button class="button red" (click)="backToPreviewInfluencer()">{{'common.btn.back' | translate}}</button>
          <button class="button green pull-right" type="submit">{{'group_details.add_to_campaign.button' | translate}}</button>
        </div>
        <div class="bottombar-buttons" *ngIf="totalSelectedPost">
          <button class="button green add-post-to-campaign-btn pull-right" type="submit">{{'common.btn.save' | translate}}</button>
          <button class="button red back-to-preview-button pull-right" (click)="backToPreviewInfluencer()">{{'common.btn.back' | translate}}</button>
        </div>
        <div class="bottombar-content flex-auto">
          <div class="row">
            <div class="col-lg-6 col-sm-12">
              <div *ngIf="totalSelectedPost > 0" class="summarize-message" [innerHTML]="'discover.campaign_to_add_post_message' | translate:{numOfPost: totalSelectedPost}">
              </div>
              <div class="material-field" [ngClass]="{'selected-campaign-to-add-post': totalSelectedPost > 0}">
                <achoo-filter-box label="{{'group_details.add_to_campaign.campaign_name' | translate}}"
                                  [options]="campaignList"
                                  placeholder="{{'group_details.add_to_campaign.dropdown_placeholder' | translate}}"
                                  [(model)]="addInfluencersCampaign.campaign_id"
                                  (selectEvent)="onCampaignSelect($event)">
                </achoo-filter-box>
              </div>
              <div class="material-field" *ngIf="campaignDescription">
                <achoo-material-textarea [numberCol]="6"
                                         [disabled]="true"
                                         placeholder="{{'group_details.add_to_campaign.campaign_brief' | translate}}"
                                         [(model)]="campaignDescription"
                                         label="{{'group_details.add_to_campaign.campaign_brief' | translate}}">
                </achoo-material-textarea>
              </div>
            </div>
            <div class="col-lg-6 col-sm-12" *ngIf="!isUsedToAddPost">
              <div class="d-flex justify-content-end flex-auto">
                <div class="add-as-accepted d-flex flex-column">
                  <div class="accepted-action">
                    <div class="d-flex flex-row flex-auto">
                      <div class="accept-title d-flex flex-auto">{{'group_details.influencer.add_to_campaign_as_accepted_title' | translate}}</div>
                      <div class="accept-btn">
                        <achoo-toggle-switch [(model)]="addInfluencersCampaign.is_accepted">
                        </achoo-toggle-switch>
                      </div>
                    </div>
                  </div>
                  <div class="accepted-description">
                    {{'group_details.influencer.add_to_campaign_as_accepted_message' | translate}}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/main/group-details/add-influencers-to-campaign/add-influencers-to-campaign.component.html